import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { clear } from './redux_toolkit/reserveSlice';
import { useNavigateWithId } from './customHooks';
import { clear as clearChange } from './redux_toolkit/reserveChangeSlice';

// 予約画面で表示する予約キャンセルボタン
function MoveTop({ lgCd }) {
  const navigate = useNavigateWithId();
  const dispatch = useDispatch();
  const location = useLocation();
  // 変更予約のTOP画面URLをReduxから取得（予約ごとに異なる）
  const changeUrl = useSelector((state) => state.reserveChange.url);

  // URLに /change/ が含まれていれば変更予約、そうでなければ新規予約
  const isChange = location.pathname.includes('/change/');
  const newOrChangeWords = isChange
    ? '変更内容が保存されない可能性があります。'
    : '選択内容が保存されない可能性があります。';

  return (
    // 右寄せ・余白はdivで担当し、aタグは文字幅のみクリック可能にする
    // className="moveTopWrapper" は SelectionSummary/ChangeSelectionSummary がこのボタンの上端位置を
    // 取得してプレビューパネルの位置合わせに使うための目印（見た目・挙動には影響しない）
    <div className="moveTopWrapper" style={{ textAlign: 'right', marginRight: '20px', marginTop: '20px' }}>
      <a
        role="button"
        style={{
          textDecoration: 'underline',
          cursor: 'pointer',
          userSelect: 'none',
        }}
        onClick={() => {
          if (window.confirm(`TOPページへ移動します。${newOrChangeWords}`)) {
            if (isChange) {
              dispatch(clearChange()); // 変更予約データをリセット
              navigate(changeUrl ? `/change/${changeUrl}` : `/${lgCd}`);
            } else {
              dispatch(clear()); // 新規予約データをリセット
              navigate(`/${lgCd}`);
            }
          }
        }}
        tabIndex={0}
      >
        最初の画面へ
      </a>
    </div>
  );
}
MoveTop.propTypes = {
  question: PropTypes.string,
  need: PropTypes.bool,
  answer: PropTypes.array,
  placeholder: PropTypes.string,
  inputType: PropTypes.number,
  num: PropTypes.number,
  setter: PropTypes.func,
}.isRequired;

export default MoveTop;
